/* globals Intercom */

export default () => {
  if (typeof Intercom === 'function') {
    // Intercomに最新のページビューを通知
    Intercom('update')
  }
}
